import { render, staticRenderFns } from "./RecommendationsComponent.vue?vue&type=template&id=3fdf5cc4&scoped=true"
import script from "./RecommendationsComponent.vue?vue&type=script&lang=js"
export * from "./RecommendationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdf5cc4",
  null
  
)

export default component.exports